//#region src/cnx-api/index.ts
/**
* Make a request to the CNX API.
*
* @param service API service/group
* @param action Service action/endpoint
* @param params Endpoint parameters
*/
async function cnxApi(service, action, ...params) {
	const conf = (await import("./conf.js")).default;
	const operations = (await conf[service]()).default.operations;
	const fn = operations[action];
	const res = await fn(...params);
	return res;
}

//#endregion
export { cnxApi };
//# sourceMappingURL=index.js.map